/* eslint-disable camelcase */
import * as THREE from 'three'

export const drawIcon = (content, options) => {
  const { font, color, position, center_x, center_y, scale, scene } = options
  position[0] -= center_x * scale
  position[1] += center_y * scale
  const labelGeometry = new THREE.TextGeometry(content, {
    font: font,
    size: 16 * scale,
    height: 0
  })

  labelGeometry.center()
  const labelMaterial = new THREE.MeshBasicMaterial({ color })
  const label = new THREE.Mesh(labelGeometry, labelMaterial)
  label.position.set(...position)
  label.renderOrder = 1
  scene.add(label)
}
